(() => {
    "use strict";
    const Xe = "2026-10-09.v1", Pe = "_printflow_order_request", oe = ["softcover_5_5x5_5", "softcover_8x8", "hardcover_8x8", "hardcover_11x11"], Qe = ["child", "mom", "dad", "grandmother", "grandfather"], et = { en: { "locale": "en-US", "childName": "Child’s first name", "adultName": "What do the children call this parent?", "namePlaceholder": "e.g. Emma", "photo": "Photo", "addPhoto": "Add a photo", "replacePhoto": "Change photo", "photoHint": "Clear face, facing the camera", "checkingPhoto": "Checking photo…", "photoReady": "Photo added", "photoBad": "Choose a JPG, PNG or WebP photo under 20 MB.", "photoUnreadable": "We could not read this photo. Try another photo.", "requiredName": "Enter the child’s first name.", "requiredAdult": "Enter what the children call this parent.", "requiredPhoto": "Add a photo for each person in the book.", "format": "Choose an available format.", "soft": "Softcover", "hard": "Hardcover", "recommended": "Recommended", "soldOut": "Unavailable", "checkout": "Checkout", "loading": "Checking options…", "adding": "Adding your book…", "checking": "Checking your cart…", "unavailable": "This book cannot be ordered right now.", "loadFailed": "We could not load the options. Try again.", "priceChanged": "The price or availability changed. Check the format before continuing.", "addRejected": "The book was not added. Check the details and try again.", "uncertain": "We are checking whether your book was added. Check your cart before trying again to avoid a duplicate.", "checkCart": "Check cart", "cartLink": "Open my cart", "defer": "Send photo after ordering", "deferred": "Photo to send after ordering", "formatLabel": "Selected format", "ready": "Check all three names and photos before continuing.", "close": "Close", "retry": "Try again", "secure": "Secure checkout", "optional": "Details and dedication", "appearance": "Appearance details (optional)", "appearancePlaceholder": "Hair, eye color or a detail to keep…", "dedication": "Dedication (optional)", "dedicationPlaceholder": "A personal message to print inside the book…" } };
    function d(u, h, m) {
        const E = document.createElement(u);
        return h && (E.className = h), m != null && (E.textContent = m), E;
    }
    function tt(u) {
        return typeof u == "string" && /^\/(?!\/)/.test(u) ? u : null;
    }
    function Ce(u) {
        return /^[1-9][0-9]{0,19}$/.test(String(u || ""));
    }
    function at() {
        if (crypto.randomUUID)
            return crypto.randomUUID();
        const u = crypto.getRandomValues(new Uint8Array(16));
        return Array.from(u, (h) => h.toString(16).padStart(2, "0")).join("");
    }
    function it(u) {
        if (u.dataset.lboMounted)
            return;
        u.dataset.lboMounted = "true";
        let h;
        try {
            h = JSON.parse(u.querySelector("[data-lbo-config]").textContent);
        }
        catch {
            return;
        }
        const m = h.rules, E = "en", c = et[E], k = (e) => u.querySelector(`[data-lbo-${e}]`), G = k("form"), de = k("submit"), ce = k("continue"), rt = k("notice"), se = k("error"), ue = k("retry"), V = k("cart-link"), J = Array.from(document.querySelectorAll("[data-sticky-source-atc], [data-local-order-open], [data-avatar-first-preview-open]")), Re = new URL(window.location.href).searchParams.get("local_library") === "1", nt = h.checkoutUrl?.endsWith("/checkout") ? h.checkoutUrl.slice(0, -8) : "/", yt = E === "fr" ? "Ajouter \xE0 ma biblioth\xE8que" : "Add to my library", fe = `local-book-order:${E}:${h.productId}`, i = { variants: [], selected: null, people: [], busy: false, loading: false, uncertain: null, returnFocus: null, ready: false, photoFlights: 0, request: null }, K = (e) => new Intl.NumberFormat(c.locale, { style: "currency", currency: h.currency }).format(e / 100), he = m?.fixedChildCount === 2 && m?.supported === true && String(m.productId) === String(h.productId) && m.market === E && Array.isArray(m.roles) && m.roles.length >= 1 && m.roles.length <= 2 && m.roles[0]?.key === "child" && m.roles.every((e, t) => Qe.includes(e.key) && (t === 0 || e.key !== "child")) && new Set(m.roles.map((e) => e.key)).size === m.roles.length && m.variantFormats && typeof m.variantFormats == "object" && Array.isArray(h.variants) && ["productUrl", "cartUrl", "cartAddUrl", "checkoutUrl"].every((e) => tt(h[e]));
        const siblingsEnabled = m.fixedChildCount === 2 && ["mom", "dad"].includes(m.roles[1]?.key);
        let personSequence = 0, addChildButton;
        function p(e, t = false) {
            const a = t ? se : rt;
            a.textContent = e || "", a.hidden = !e, t && e && a.focus({ preventScroll: true });
        }
        function T() {
            return i.variants.find((e) => e.id === i.selected);
        }
        function _t(e) {
            const t = m.variantFormats[e.id];
            return `${t?.startsWith("hardcover") ? c.hard : c.soft} \xB7 ${t === "softcover_5_5x5_5" ? "5.5 × 5.5" : t === "hardcover_11x11" ? "11 × 11" : "8 × 8"} in`;
        }
        function M(e) {
            i.busy = e, u.setAttribute("aria-busy", String(e)), k("close").disabled = e;
            for (const t of G.elements)
                t.disabled = e || !!i.uncertain;
            if (!e && !i.uncertain)
                for (const t of k("formats").querySelectorAll("input"))
                    t.disabled = !i.variants.find((a) => a.id === t.value)?.available;
            I();
        }
        function I() {
            const e = T(), t = i.variants.filter((a) => a.available).reduce((a, r) => !a || r.price < a.price ? r : a, null);
            for (const a of document.querySelectorAll("[data-local-order-starting-price]"))
                a.textContent = t ? K(t.price) : c.soldOut;
            for (const a of document.querySelectorAll("[data-local-order-starting-label]"))
                a.hidden = !t;
            for (const a of document.querySelectorAll("[data-local-order-starting-compare]"))
                a.hidden = !t || !t.compareAt || t.compareAt <= t.price, a.textContent = a.hidden ? "" : K(t.compareAt);
            de.disabled = !!i.preparing || i.busy || i.loading || i.photoFlights > 0 || !i.uncertain && (!i.ready || !e?.available), de.textContent = i.preparing ? E === "fr" ? "Pr\xE9paration du livre\u2026" : "Preparing your book\u2026" : i.busy ? i.uncertain ? c.checking : c.adding : i.uncertain ? c.checkCart : `${c.checkout}${e ? " \xB7 " + K(e.price) : ""} \u2192`, ce.disabled = de.disabled || !!i.uncertain, ce.textContent = i.busy && i.request?.destination === "shopping" ? c.adding : E === "fr" ? "Continuer mes achats" : "Continue shopping", e && i.notifiedVariant !== e.id && (i.notifiedVariant = e.id, document.dispatchEvent(new CustomEvent("local-book-order:variant-changed", { detail: { productId: String(h.productId), variantId: e.id, format: m.variantFormats[e.id] } })));
            for (const a of J)
                a.disabled = !he, a.setAttribute("aria-disabled", String(a.disabled));
            W();
        }
        function Se(e) {
            return e.filter((t) => Ce(t.id) && oe.includes(m.variantFormats[String(t.id)])).map((t) => ({ id: String(t.id), price: Number(t.price), compareAt: Number(t.compare_at_price || 0), available: t.available === true }));
        }
        let Y = null;
        function ot() {
            return Y || (Y = new Promise((e) => {
                const t = u.dataset.lboFrontCover;
                if (!t) {
                    e(null);
                    return;
                }
                const a = new Image();
                a.crossOrigin = "anonymous", a.onload = () => {
                    try {
                        const r = (n) => {
                            const o = document.createElement("canvas");
                            o.width = o.height = 256;
                            const l = o.getContext("2d");
                            if (!l)
                                throw Error("Canvas unavailable");
                            const f = n ? 10 : 4, g = (y, b) => {
                                l.beginPath(), y.forEach(([_, v], L) => L ? l.lineTo(_, v) : l.moveTo(_, v)), l.closePath(), l.fillStyle = b, l.fill();
                            };
                            g([[36, 34], [216, 22], [216, 214 + f], [36, 226 + f]], n ? "#635443" : "#c5b7a7"), g([[42, 218], [211, 208], [216, 211 + f], [42, 222 + f]], "#f5eee0"), l.strokeStyle = "#cbbfac", l.lineWidth = 0.65;
                            for (let y = 2; y < f; y += 2)
                                l.beginPath(), l.moveTo(44, 219 + y), l.lineTo(215, 209 + y), l.stroke();
                            g([[36, 34], [42, 30], [42, 218], [36, 224]], n ? "#79674f" : "#baa98e"), l.save(), l.setTransform(169 / a.naturalWidth, -10 / a.naturalWidth, 0, 188 / a.naturalHeight, 42, 30), l.drawImage(a, 0, 0), l.restore();
                            const x = l.createLinearGradient(42, 0, 57, 0);
                            return x.addColorStop(0, "#0000002b"), x.addColorStop(0.35, "#ffffff0d"), x.addColorStop(1, "#00000000"), g([[42, 30], [57, 29.1], [57, 217.1], [42, 218]], x), o.toDataURL("image/png");
                        };
                        e({ soft: r(false), hard: r(true) });
                    }
                    catch {
                        e(null);
                    }
                }, a.onerror = () => e(null), a.src = t;
            }), Y);
        }
        function Ue() {
            const e = k("formats");
            e.replaceChildren(), i.variants.sort((t, a) => oe.indexOf(m.variantFormats[t.id]) - oe.indexOf(m.variantFormats[a.id]));
            for (const t of i.variants) {
                const a = m.variantFormats[t.id], r = d("label", "lbo__format"), n = d("input");
                n.type = "radio", n.name = "lbo-format", n.value = t.id, n.checked = t.id === i.selected, n.disabled = !t.available || i.busy || !!i.uncertain, r.classList.toggle("is-unavailable", !t.available);
                const o = d("span", `lbo__format-art lbo__format-art--${a}`);
                o.setAttribute("aria-hidden", "true");
                const l = d("i", "lbo__mini-book"), f = u.dataset.lboFrontCover;
                f && (l.style.backgroundImage = `url(${JSON.stringify(f)})`), o.append(l), ot().then((y) => {
                    if (!y || !l.isConnected)
                        return;
                    const b = d("img", "lbo__book-png");
                    b.alt = "", b.width = b.height = 256, b.decoding = "async", b.src = y[a.startsWith("hardcover") ? "hard" : "soft"], o.replaceChildren(b);
                });
                const g = d("span", "lbo__format-copy");
                g.append(d("strong", "", a.startsWith("hardcover") ? c.hard : c.soft), d("span", "lbo__format-size", `${a === "softcover_5_5x5_5" ? "5.5 × 5.5" : a === "hardcover_11x11" ? "11 × 11" : "8 × 8"} in`)), g.append(d("span", "lbo__format-price", t.available ? K(t.price) : c.soldOut)), a === "hardcover_8x8" && r.append(d("span", "lbo__format-badge", c.recommended)), E === "en" && a === "hardcover_11x11" && r.append(d("span", "lbo__format-badge lbo__format-badge--premium", "Premium"));
                const x = d("span", "lbo__format-check");
                x.setAttribute("aria-hidden", "true"), r.append(n, o, g, x), e.append(r), n.addEventListener("change", () => {
                    i.busy || i.uncertain || (i.selected = t.id, p(""), I());
                });
            }
        }
        const w = E === "fr", me = [["", null, w ? "Comme sur la photo" : "As in the photo"], ["darkBrown", "#472d21", w ? "Marron fonc\xE9" : "Dark brown"], ["brown", "#7d5133", w ? "Marron" : "Brown"], ["hazel", "#959653", w ? "Noisette" : "Hazel"], ["green", "#659676", w ? "Verts" : "Green"], ["blue", "#68a9c5", w ? "Bleus" : "Blue"]], pe = (e) => me.find((t) => t[0] === e)?.[2] || me[0][2];
        let C = null, Z = null, Te = false, lt = 0, D = null;
        const O = /* @__PURE__ */ new Map();
        function je(e, t, a) {
            let r;
            return Promise.race([e, new Promise((n) => {
                    r = setTimeout(() => n(a), t);
                })]).finally(() => clearTimeout(r));
        }
        const ge = () => new Promise((e) => requestAnimationFrame(() => requestAnimationFrame(e)));
        function X() {
            Te = true, u.dataset.photoProcessing = "browser", C?.terminate(), C = null, D && (URL.revokeObjectURL(D), D = null);
            for (const e of O.values())
                clearTimeout(e.timer), e.reject(Error("WORKER_UNAVAILABLE"));
            O.clear();
        }
        function Q(e, t = {}) {
            return new Promise((a, r) => {
                if (!C) {
                    r(Error("WORKER_UNAVAILABLE"));
                    return;
                }
                const n = ++lt, o = setTimeout(X, 12e3);
                O.set(n, { resolve: a, reject: r, timer: o });
                try {
                    C.postMessage({ id: n, op: e, ...t });
                }
                catch {
                    clearTimeout(o), O.delete(n), r(Error("WORKER_UNAVAILABLE"));
                }
            });
        }
        function be() {
            return Te || !u.dataset.lboPhotoWorker || typeof Worker != "function" ? Promise.resolve(null) : Z || (Z = (async () => {
                try {
                    const e = new AbortController(), t = setTimeout(() => e.abort(), 4e3);
                    let a;
                    try {
                        const r = await fetch(u.dataset.lboPhotoWorker, { cache: "force-cache", credentials: "omit", signal: e.signal });
                        if (!r.ok)
                            throw Error("WORKER_UNAVAILABLE");
                        a = await r.text();
                    }
                    finally {
                        clearTimeout(t);
                    }
                    return D = URL.createObjectURL(new Blob([a], { type: "text/javascript" })), C = new Worker(D), C.onmessage = ({ data: r }) => {
                        const n = O.get(r.id);
                        n && (clearTimeout(n.timer), O.delete(r.id), r.error ? n.reject(Error(r.error)) : n.resolve(r.result));
                    }, C.onerror = () => X(), await Q("ready"), u.dataset.photoProcessing = "background", C;
                }
                catch {
                    return X(), null;
                }
            })(), Z);
        }
        function ze(e) {
            return new Promise((t, a) => {
                const r = URL.createObjectURL(e), n = new Image();
                let o;
                const l = () => {
                    clearTimeout(o), URL.revokeObjectURL(r), n.onload = n.onerror = null;
                };
                o = setTimeout(() => {
                    l(), n.src = "", a(Error("PHOTO_UNREADABLE"));
                }, 8e3), n.onload = () => {
                    l(), t(n);
                }, n.onerror = () => {
                    l(), a(Error("PHOTO_UNREADABLE"));
                }, n.src = r;
            });
        }
        async function dt(e) {
            const t = await ze(e);
            await ge();
            const a = Math.min(1, 1280 / Math.max(t.naturalWidth, t.naturalHeight)), r = document.createElement("canvas");
            r.width = Math.max(1, Math.round(t.naturalWidth * a)), r.height = Math.max(1, Math.round(t.naturalHeight * a));
            const n = r.getContext("2d");
            if (!n)
                throw Error("CANVAS_UNAVAILABLE");
            n.drawImage(t, 0, 0, r.width, r.height);
            const o = await je(new Promise((l) => r.toBlob(l, "image/jpeg", 0.9)), 4e3, null);
            if (!o)
                throw Error("PHOTO_UNREADABLE");
            return { blob: o, width: t.naturalWidth, height: t.naturalHeight, image: t };
        }
        async function ct(e, t) {
            const a = e.original, r = e.workerKey;
            if (r && await be())
                try {
                    return await Q("crop", { key: r, bounds: t });
                }
                catch {
                }
            const n = e.fallbackImage || await ze(a);
            e.original === a && (e.fallbackImage = n), await ge();
            const o = document.createElement("canvas");
            o.width = o.height = t.size;
            const l = o.getContext("2d");
            if (!l)
                throw Error("CANVAS_UNAVAILABLE");
            return l.drawImage(n, t.x, t.y, t.side, t.side, 0, 0, t.size, t.size), je(new Promise((f) => o.toBlob(f, "image/jpeg", 0.94)), 4e3, null);
        }
        function Fe(e) {
            e && C && Q("release", { key: e }).catch(() => {
            });
        }
        function Oe(e) {
            const t = e.originalImage.naturalWidth, a = e.originalImage.naturalHeight, r = e.crop, n = Math.min(t, a) / r.zoom;
            return r.x = Math.max(-(t - n) / (2 * n), Math.min((t - n) / (2 * n), r.x)), r.y = Math.max(-(a - n) / (2 * n), Math.min((a - n) / (2 * n), r.y)), { side: n, x: (t - n) / 2 - r.x * n, y: (a - n) / 2 - r.y * n };
        }
        function st(e) {
            if (e.paintId = 0, !e.originalImage || !e.stageSize)
                return;
            Oe(e);
            const t = e.stageSize * 0.8;
            e.frameImage.style.transform = `translate(-50%,-50%) translate3d(${e.crop.x * t}px,${e.crop.y * t}px,0) scale(${e.crop.zoom})`, e.zoom.value = String(e.crop.zoom), e.readout.textContent = e.crop.zoom.toFixed(2) + "\xD7";
        }
        function qe(e) {
            e.paintId || (e.paintId = requestAnimationFrame(() => st(e)));
        }
        function Ne(e) {
            if (!e.originalImage || !e.stageSize)
                return;
            const t = e.stageSize * 0.8 / Math.min(e.originalImage.naturalWidth, e.originalImage.naturalHeight);
            e.frameImage.style.width = e.originalImage.naturalWidth * t + "px", e.frameImage.style.height = e.originalImage.naturalHeight * t + "px", qe(e);
        }
        async function ee(e) {
            if (!e.originalImage)
                return false;
            const t = e.cropRevision, a = e.sequence;
            if (e.checkedRevision === t)
                return !!e.file;
            if (e.pendingRevision === t && e.pendingJob)
                return e.pendingJob;
            e.checkTimer && (clearTimeout(e.checkTimer), e.checkTimer = null);
            const r = () => !e.removed && e.sequence === a && e.cropRevision === t, n = (async () => {
                e.status.classList.remove("is-photo-error"), e.status.textContent = "";
                try {
                    const o = Oe(e);
                    o.size = Math.max(1, Math.min(1200, Math.floor(o.side)));
                    const l = await ct(e, o);
                    if (!r())
                        return false;
                    if (!l)
                        throw Error("CROP_FAILED");
                    return e.url && URL.revokeObjectURL(e.url), e.file = new File([l], e.role === "child" ? "child-photo.jpg" : "adult-photo.jpg", { type: "image/jpeg" }), e.url = URL.createObjectURL(l), e.checkedRevision = t, e.input.setCustomValidity(""), e.status.textContent = "", (se.textContent === c.requiredPhoto || se.textContent === c.photoUnreadable) && p("", true), true;
                }
                catch {
                    return r() && (e.file = null, e.status.textContent = c.photoUnreadable, e.status.classList.add("is-photo-error")), false;
                }
            })();
            e.pendingRevision = t, e.pendingJob = n;
            try {
                return await n;
            }
            finally {
                e.pendingJob === n && (e.pendingJob = null, e.pendingRevision = null);
            }
        }
        function te(e) {
            e.cropRevision++, e.checkedRevision = null, e.file = null, e.status.classList.remove("is-photo-error"), e.status.textContent = "", qe(e), clearTimeout(e.checkTimer), e.checkTimer = setTimeout(() => {
                e.checkTimer = null, ee(e);
            }, 350);
        }
        const Be = window.matchMedia("(prefers-reduced-motion: reduce)");
        function ve(e) {
            return u.open && !document.hidden && !Be.matches && !!e.originalImage && !e.gestureHeld && !i.busy && !i.preparing && !i.uncertain;
        }
        function q(e) {
            clearTimeout(e.gestureTimer), e.gestureTimer = null, e.gesture.hidden = true;
        }
        function j(e, t = 12e3) {
            q(e), ve(e) && (e.gestureTimer = setTimeout(() => Ve(e), t));
        }
        function Ve(e) {
            q(e), ve(e) && (e.gesture.hidden = false, e.gestureTimer = setTimeout(() => j(e), 2400));
        }
        function W() {
            for (const e of i.people)
                ve(e) ? e.gestureTimer || j(e) : q(e);
        }
        document.addEventListener("visibilitychange", W), Be.addEventListener?.("change", W), window.addEventListener("pageshow", W);
        function $(e, t, a) {
            if (!e.originalImage || i.busy || i.uncertain)
                return;
            const r = e.crop.zoom, n = Math.max(1, Math.min(3, t));
            if (n !== r) {
                if (a) {
                    const o = e.stageSize * 0.8, l = (a.x - e.stageSize / 2) / o, f = (a.y - e.stageSize / 2) / o;
                    e.crop.x = l - (l - e.crop.x) * n / r, e.crop.y = f - (f - e.crop.y) * n / r;
                }
                j(e), e.crop.zoom = n, te(e);
            }
        }
        function ut(e, t, a) {
            e.card = t, e.crop = { zoom: 1, x: 0, y: 0 }, e.cropRevision = 0;
            const r = d("section", "lbo-inline");
            r.hidden = true, r.setAttribute("aria-label", w ? "Sa photo et la couleur de ses yeux" : "Photo and eye color");
            const n = d("div", "lbo-inline__photo"), o = d("div", "lbo-inline__stage"), l = d("img", "lbo-inline__image");
            l.alt = w ? "Photo de son personnage" : "Your uploaded photo", l.draggable = false, o.tabIndex = 0, o.setAttribute("role", "group"), o.setAttribute("aria-label", w ? "Cadrage du visage. Glissez la photo ou utilisez les fl\xE8ches." : "Face crop. Drag the photo or use the arrow keys.");
            const f = d("span", "lbo-inline__grid");
            f.setAttribute("aria-hidden", "true");
            for (let s = 0; s < 4; s++)
                f.append(d("i"));
            o.append(l, f);
            const g = d("span", "lbo-inline__gesture");
            g.hidden = true, g.setAttribute("aria-hidden", "true"), g.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.65" stroke-linecap="round" stroke-linejoin="round"><path fill="#2c5f5d" d="M8 13V5a1.5 1.5 0 0 1 3 0v5-2a1.5 1.5 0 0 1 3 0v2-1a1.5 1.5 0 0 1 3 0v2a1.5 1.5 0 0 1 3 0v5c0 3-2 5-5 5h-2c-2 0-3-1-4-3l-3-4a1.5 1.5 0 0 1 2-2l2 2"/></svg>', o.append(g);
            const x = d("div", "lbo-inline__controls"), y = d("button", "lbo-inline__zoom", "\u2212"), b = d("button", "lbo-inline__zoom", "+"), _ = d("input"), v = d("output", "lbo-inline__readout", "1.00\xD7"), L = d("button", "lbo-inline__reset", w ? "Recentrer" : "Center");
            y.type = b.type = L.type = "button", y.setAttribute("aria-label", w ? "R\xE9duire le zoom" : "Zoom out"), b.setAttribute("aria-label", w ? "Agrandir le zoom" : "Zoom in"), _.type = "range", _.min = "1", _.max = "3", _.step = ".01", _.value = "1", _.setAttribute("aria-label", w ? "Zoom de la photo" : "Photo zoom"), x.append(y, _, v, b);
            const S = d("button", "lbo-inline__change", c.replacePhoto);
            S.type = "button";
            const z = d("div", "lbo-inline__actions");
            if (z.append(L, S), n.append(o, x, z), r.append(n), e.role === "child") {
                const s = d("fieldset", "lbo-inline__eyes"), A = d("legend", "", w ? "Couleur des yeux" : "Eye color"), Ke = d("span", "lbo-inline__selected", pe("")), Ye = d("div", "lbo-inline__swatches");
                s.append(A, Ke, Ye);
                for (const [re, Ae, Ze] of me) {
                    const Ie = d("label", "lbo-inline__swatch"), F = d("input");
                    F.type = "radio", F.name = `lbo-inline-eyes-${h.productId}-${a}`, F.value = re, F.checked = !re, F.setAttribute("aria-label", Ze), Ie.title = Ze;
                    const ne = d("span", "lbo-inline__color", Ae ? "" : w ? "Photo" : "Photo");
                    Ae ? ne.style.backgroundColor = Ae : ne.classList.add("is-photo"), ne.setAttribute("aria-hidden", "true"), Ie.append(F, ne), Ye.append(Ie), F.addEventListener("change", () => {
                        e.eyeValue = re, Ke.textContent = pe(re);
                    });
                }
                r.append(s);
            }
            t.append(r), Object.assign(e, { inline: r, stage: o, frameImage: l, zoom: _, readout: v, change: S, gesture: g }), S.addEventListener("click", () => e.input.click()), _.addEventListener("input", () => $(e, Number(_.value))), y.addEventListener("click", () => $(e, e.crop.zoom - 0.1)), b.addEventListener("click", () => $(e, e.crop.zoom + 0.1)), L.addEventListener("click", () => {
                e.originalImage && (j(e), e.crop = { zoom: 1, x: 0, y: 0 }, te(e));
            }), _.addEventListener("pointerdown", () => {
                e.gestureHeld = true, q(e);
            });
            const H = () => {
                e.gestureHeld = false, j(e);
            };
            for (const s of ["pointerup", "pointercancel", "lostpointercapture", "blur"])
                _.addEventListener(s, H);
            const R = /* @__PURE__ */ new Map();
            let U = null, ie = null;
            const Ee = (s) => ({ x: s.clientX - ie.left, y: s.clientY - ie.top }), Le = () => {
                const s = [...R.values()];
                return s.length === 1 ? { ...s[0], distance: 0 } : s.length >= 2 ? { x: (s[0].x + s[1].x) / 2, y: (s[0].y + s[1].y) / 2, distance: Math.hypot(s[0].x - s[1].x, s[0].y - s[1].y) } : null;
            };
            o.addEventListener("pointerdown", (s) => {
                !e.originalImage || i.busy || i.uncertain || (s.preventDefault(), e.gestureHeld = true, q(e), ie = o.getBoundingClientRect(), o.setPointerCapture(s.pointerId), R.set(s.pointerId, Ee(s)), U = Le());
            }), o.addEventListener("pointermove", (s) => {
                if (!R.has(s.pointerId) || i.busy || i.uncertain)
                    return;
                s.preventDefault(), R.set(s.pointerId, Ee(s));
                const A = Le();
                U && A && (A.distance && U.distance && $(e, e.crop.zoom * A.distance / U.distance, A), e.crop.x += (A.x - U.x) / (e.stageSize * 0.8), e.crop.y += (A.y - U.y) / (e.stageSize * 0.8), te(e)), U = A;
            });
            const vt = (s) => {
                R.delete(s.pointerId) && (U = Le(), e.gestureHeld = R.size > 0, e.gestureHeld || j(e));
            };
            for (const s of ["pointerup", "pointercancel", "lostpointercapture"])
                o.addEventListener(s, vt);
            o.addEventListener("wheel", (s) => {
                !e.originalImage || i.busy || i.uncertain || (s.preventDefault(), ie = o.getBoundingClientRect(), $(e, e.crop.zoom * (s.deltaY < 0 ? 1.08 : 1 / 1.08), Ee(s)));
            }, { passive: false }), o.addEventListener("keydown", (s) => {
                const A = { ArrowLeft: [-0.035, 0], ArrowRight: [0.035, 0], ArrowUp: [0, -0.035], ArrowDown: [0, 0.035] };
                !A[s.key] || !e.originalImage || i.busy || i.uncertain || (s.preventDefault(), j(e), e.crop.x += A[s.key][0], e.crop.y += A[s.key][1], te(e));
            });
            const Je = () => {
                e.stageSize = o.clientWidth, Ne(e);
            };
            typeof ResizeObserver == "function" ? (e.resizeObserver = new ResizeObserver(Je)).observe(o) : window.addEventListener("resize", (e.onWindowResize = Je));
        }
        async function Me(e, t) {
            const a = ++e.sequence;
            if (e.input.setCustomValidity(""), !t)
                return;
            if (!["image/jpeg", "image/png", "image/webp"].includes(t.type) || !t.size || t.size > 20 * 1024 * 1024) {
                e.status.textContent = c.photoBad, e.originalImage || e.input.setCustomValidity(c.photoBad);
                return;
            }
            const r = e.photoKey + "-" + a;
            i.photoFlights++, e.status.textContent = w ? "Chargement de la photo\u2026" : "Loading photo\u2026", I();
            let n = false;
            try {
                let o;
                if (await be())
                    try {
                        o = await Q("preview", { key: r, file: t });
                    }
                    catch {
                    }
                if (o || (o = await dt(t)), e.removed || e.sequence !== a)
                    return;
                Fe(e.workerKey), e.displayUrl && URL.revokeObjectURL(e.displayUrl), e.url && URL.revokeObjectURL(e.url), e.url = null, e.original = t, e.originalImage = { naturalWidth: o.width, naturalHeight: o.height }, e.fallbackImage = o.image || null, e.workerKey = o.image ? null : r, e.displayUrl = URL.createObjectURL(o.blob), e.frameImage.src = e.displayUrl, e.crop = { zoom: 1, x: 0, y: 0 }, e.cropRevision++, e.checkedRevision = null, e.file = null, e.inline.append(e.status), e.inline.hidden = false, e.card.classList.add("has-source"), e.stageSize = e.stage.clientWidth, Ne(e), Ve(e), e.role === "child" && (u.dataset.childPhoto = "true"), n = true, e.status.textContent = "", B(), await ge(), e.sequence === a && ee(e);
            }
            catch {
                e.sequence === a && (e.status.textContent = c.photoUnreadable, e.status.classList.add("is-photo-error"));
            }
            finally {
                n || Fe(r), i.photoFlights = Math.max(0, i.photoFlights - 1), I();
            }
        }
        async function ft() {
            for (const e of i.people)
                if (!await ee(e)) {
                    if (e.checkedRevision !== e.cropRevision && e.originalImage && await ee(e))
                        continue;
                    return p(e.status.textContent || c.requiredPhoto, true), e.stage.focus({ preventScroll: false }), false;
                }
            return true;
        }
        function addPerson(t, a, extra = false) {
            const e = k("people");
            const r = { photoKey: `person-${++personSequence}`, extra, role: t.key, file: null, url: null, sequence: 0, deferred: false, eyeValue: "" }, n = d("fieldset", "lbo__person"), o = d("legend", "lbo__person-title");
            o.textContent = t.key === "child" ? w ? "Son personnage" : "Child" : t.label, n.append(o);
            n.dataset.lboPersonKey = r.photoKey;
            n.dataset.lboPersonRole = t.key;
            n.dataset.lboDetailsPrefix = extra ? `_printflow_${r.photoKey.replace("-", "_")}` : t.key === "child" ? "_printflow_child" : "_printflow_secondary";
            const l = d("label", "lbo__upload"), f = d("input", "lbo__file"), g = d("img", "lbo__photo");
            f.type = "file", f.required = true, f.accept = "image/jpeg,image/png,image/webp", f.id = `lbo-photo-${h.productId}-${a}`, f.setAttribute("aria-label", `${c.photo} \u2014 ${t.label}`), g.alt = "", g.hidden = true;
            const x = d("span", "lbo__upload-icon", "+"), y = d("span", "lbo__upload-text", c.addPhoto);
            l.append(f, g, x, y);
            const b = d("div", "lbo__person-fields"), _ = d("label", "lbo__label", t.key === "child" ? c.childName : c.adultName), v = d("input", "lbo__input");
            v.type = "text", v.id = `lbo-name-${h.productId}-${a}`, v.name = `lbo-name-${t.key}`, v.maxLength = 100, v.autocomplete = "off", v.required = true, v.placeholder = t.key === "child" ? c.namePlaceholder : t.addressTermDefault || t.label, v.value = t.key === "child" ? "" : t.addressTermDefault || "", _.htmlFor = v.id;
            const L = d("span", "lbo__photo-status");
            L.id = `lbo-photo-status-${h.productId}-${a}`, L.setAttribute("aria-live", "polite"), f.setAttribute("aria-describedby", L.id), b.append(_, v, L);
            const S = d("div", "lbo__photo-column");
            S.append(l), n.append(S, b), (extra ? e.insertBefore(n, addChildButton) : e.append(n)), Object.assign(r, { input: f, preview: g, buttonText: y, status: L, name: v, upload: l, photoColumn: S, fields: b }), ut(r, n, a), f.addEventListener("change", () => Me(r, f.files?.[0])), v.addEventListener("input", () => v.setCustomValidity("")), l.addEventListener("dragover", (z) => {
                z.preventDefault(), l.classList.add("is-drag-over");
            }), l.addEventListener("dragleave", () => l.classList.remove("is-drag-over")), l.addEventListener("drop", (z) => {
                if (z.preventDefault(), l.classList.remove("is-drag-over"), i.busy || i.uncertain)
                    return;
                const H = z.dataTransfer?.files?.[0];
                if (H) {
                    const R = new DataTransfer();
                    R.items.add(H), f.files = R.files, Me(r, H);
                }
            }), i.people.push(r);
            if (extra && m.fixedChildCount !== 2) {
                const remove = d("button", "lbo__remove-child", "Remove");
                remove.type = "button";
                n.append(remove);
                remove.addEventListener("click", () => {
                    if (i.busy || i.preparing || i.uncertain)
                        return;
                    r.removed = true;
                    r.sequence++;
                    clearTimeout(r.checkTimer);
                    q(r);
                    Fe(r.workerKey);
                    r.resizeObserver?.disconnect();
                    if (r.onWindowResize)
                        window.removeEventListener("resize", r.onWindowResize);
                    for (const url of [r.url, r.displayUrl])
                        if (url)
                            URL.revokeObjectURL(url);
                    r.original = r.originalImage = r.fallbackImage = r.file = null;
                    n.dispatchEvent(new CustomEvent("lbo:person-removed"));
                    n.remove();
                    i.people.splice(i.people.indexOf(r), 1);
                    reflectChildren();
                    addChildButton.focus();
                });
                n.dispatchEvent(new CustomEvent("lbo:person-added", { bubbles: true }));
            }
            return r;
        }
        function reflectChildren() {
            const children = i.people.filter(person => person.role === "child");
            u.dataset.peopleCount = String(i.people.length);
            children.forEach((person, index) => {
                const label = children.length > 1 ? `Child ${index + 1}` : "Child";
                person.card.querySelector("legend").textContent = label;
                person.name.setAttribute("aria-label", `${label} – first name`);
                person.input.setAttribute("aria-label", `Photo – ${label}`);
                person.card.querySelector(".lbo__remove-child")?.setAttribute("aria-label", `Remove child ${index + 1}`);
            });
            addChildButton.hidden = children.length >= 3;
            const dedication = k("dedication");
            if (!dedication.dataset.singlePlaceholder)
                dedication.dataset.singlePlaceholder = dedication.placeholder;
            dedication.placeholder = children.length > 1 ? "Thank you for all our adventures together. With love from\u2026" : dedication.dataset.singlePlaceholder;
        }
        function ht() {
            k("people").replaceChildren();
            u.dataset.peopleCount = "3";
            m.roles.forEach((role, index) => addPerson(role, index));
            addChildButton = d("span");
            addChildButton.hidden = true;
            k("people").insertBefore(addChildButton, i.people[1].card);
            addPerson({ key: "child", label: "Child 2" }, personSequence, true);
            reflectChildren();
        }
        async function ye(e, t = {}) {
            const a = new AbortController(), r = setTimeout(() => a.abort(), t.method === "POST" ? 6e4 : 15e3);
            try {
                return await fetch(e, { credentials: "same-origin", cache: "no-store", ...t, signal: a.signal, headers: { Accept: "application/json", ...t.headers || {} } });
            }
            finally {
                clearTimeout(r);
            }
        }
        async function De() {
            const e = await ye(h.productUrl + ".js");
            if (!e.ok)
                throw new Error("PRODUCT_UNAVAILABLE");
            const t = await e.json();
            if (String(t.id) !== String(h.productId) || !Array.isArray(t.variants))
                throw new Error("PRODUCT_MISMATCH");
            const a = Se(t.variants);
            if (!a.length || a.some((o) => !Number.isSafeInteger(o.price) || o.price < 0))
                throw new Error("PRODUCT_INVALID");
            const r = T(), n = r && { price: r.price, available: r.available };
            if (i.variants = a, !i.selected) {
                const o = new URL(window.location.href).searchParams.get("variant");
                i.selected = (a.find((l) => l.id === o) || a.find((l) => l.available && m.variantFormats[l.id] === "hardcover_8x8") || a.find((l) => l.available) || a[0]).id;
            }
            return i.ready = true, Ue(), I(), !!n && (!T() || T().price !== n.price || T().available !== n.available);
        }
        function We(e) {
            try {
                const t = new URL(e);
                return t.protocol === "https:" && t.hostname === "cdn.shopify.com" && !t.username && !t.password && !t.port && /^\/s\/files\//.test(t.pathname);
            }
            catch {
                return false;
            }
        }
        function $e(e, t) {
            const a = e?.properties;
            return (!t.siblings || t.siblings.every((child, index) => a?.[`_printflow_child_${index + 2}_media`] === child.media && a?.[`_printflow_child_${index + 2}_name`] === child.name)) && e && a?.[Pe] === t.id && String(e.product_id) === String(h.productId) && String(e.variant_id || e.id) === t.variantId && Number(e.quantity) >= 1 && typeof a._printflow_child_name == "string" && a._printflow_child_name.trim() && (t.media ? a._printflow_child_media === t.media.child : We(a._printflow_child_photo) || /^pfo_[a-f0-9-]{36}$/i.test(a._printflow_child_media || "")) && (!i.people[1] || typeof a._printflow_secondary_address_term == "string" && a._printflow_secondary_address_term.trim() && (t.media ? a._printflow_secondary_media === t.media.secondary : We(a._printflow_secondary_photo) || /^pfo_[a-f0-9-]{36}$/i.test(a._printflow_secondary_media || "")));
        }
        async function ae(e) {
            const t = await ye(h.cartUrl + ".js");
            if (!t.ok)
                throw new Error("CART_UNAVAILABLE");
            const a = await t.json();
            if (!Array.isArray(a.items))
                throw new Error("CART_INVALID");
            e.cartToken = a.token;
            const r = a.items.find((n) => $e(n, e)) || null;
            if (r && r.properties?._printflow_child_media) {
                const references = [r.properties._printflow_child_media, r.properties._printflow_secondary_media, ...(e.siblings || []).map(child => child.media)].filter(Boolean);
                for (let index = 0; index < references.length; index += 2)
                    await window.PrintFlowPrivatePhotos.attach({ references: references.slice(index, index + 2), cartToken: a.token });
            }
            return r;
        }
        function mt(e) {
            try {
                sessionStorage.setItem(fe, JSON.stringify({ id: e.id, variantId: e.variantId, destination: e.destination, media: e.media, siblings: e.siblings }));
            }
            catch {
            }
        }
        function He() {
            try {
                sessionStorage.removeItem(fe);
            }
            catch {
            }
        }
        function _e(e) {
            He(), window.location.assign(e?.destination === "shopping" ? nt + "?library_added=1#book-bundles" : h.checkoutUrl);
        }
        async function pt() {
            M(true), p(""), p(c.checking);
            try {
                if (await ae(i.uncertain)) {
                    _e(i.uncertain);
                    return;
                }
                p(""), p(c.uncertain, true);
            }
            catch {
                p(""), p(c.uncertain, true);
            }
            finally {
                V.hidden = false, M(false);
            }
        }
        function Ge() {
            for (const e of i.people) {
                if (!e.name.value.trim())
                    return e.name.setCustomValidity(e.role === "child" ? c.requiredName : c.requiredAdult), e.name.reportValidity(), e.name.focus(), false;
                if (e.name.setCustomValidity(""), !e.originalImage)
                    return e.input.setCustomValidity(c.requiredPhoto), p(c.requiredPhoto, true), e.input.focus(), false;
                e.input.setCustomValidity("");
            }
            return T()?.available ? G.reportValidity() : (p(c.format, true), k("formats").querySelector("input:not(:disabled)")?.focus(), false);
        }
        async function gt(e) {
            if (e.preventDefault(), i.preparing || i.busy || i.loading || i.photoFlights)
                return;
            if (i.uncertain) {
                await pt();
                return;
            }
            if (p("", true), p(""), !Ge())
                return;
            i.preparing = true, I();
            let t = false, a = null;
            try {
                if (!await ft() || !Ge())
                    return;
                if (u.dataset.lboPreview === "true") {
                    p(`Forhåndsvisning: ${i.people.filter(person => person.role === "child").map(person => person.name.value.trim()).join(", ")} og ${i.people[1]?.name.value.trim() || ""}. Navn og bilder er klare. Ingen bestilling er opprettet.`);
                    return;
                }
                if (i.preparing = false, M(true), await De()) {
                    p(c.priceChanged, true);
                    return;
                }
                if (!T()?.available) {
                    p(c.format, true);
                    return;
                }
                if (i.people.length !== 3 || i.people.filter(p => p.role === "child").length !== 2) {
                    p(c.requiredName, true);
                    return;
                }
                a = { id: at(), variantId: i.selected, destination: e.submitter === ce ? "shopping" : "checkout" }, await ae(a);
                const r = new FormData();
                r.append("id", a.variantId), r.append("quantity", "1");
                const n = (v, L) => r.append(`properties[${v}]`, L);
                if (E === "en") {
                    const detail = (name) => G.querySelector('input[type="hidden"][name="properties[' + name + ']"]')?.value || "";
                    const age = detail("_printflow_child_age_value"), unit = detail("_printflow_child_age_unit");
                    if (/^(?:[1-9]|1[0-8])$/.test(age) && (unit === "years" || unit === "months" && Number(age) <= 12)) {
                        n("_printflow_child_age_value", age);
                        n("_printflow_child_age_unit", unit);
                    }
                    const gender = detail("_printflow_child_gender");
                    if (gender === "boy" || gender === "girl")
                        n("_printflow_child_gender", gender);
                    const colours = ["darkBrown", "brown", "hazel", "green", "blue"];
                    const childEyes = detail("_printflow_child_eye_color"), secondaryEyes = detail("_printflow_secondary_eye_color");
                    if (colours.includes(childEyes))
                        n("_printflow_child_eye_color", childEyes);
                    if (i.people[1] && colours.includes(secondaryEyes))
                        n("_printflow_secondary_eye_color", secondaryEyes);
                }
                n(Pe, a.id), n("_printflow_native_contract", Xe), n("_printflow_language", E);
                const o = i.people[0];
                if (n("_printflow_child_name", o.name.value.trim()), !window.PrintFlowPrivatePhotos || typeof a.cartToken != "string")
                    throw new Error("PRIVATE_PHOTO_UNAVAILABLE");
                const l = i.people[1], extraPeople = siblingsEnabled ? i.people.filter(person => person.extra) : [];
                // Independent photo transfers share one session and keep their original role keys.
                // Wait for every transfer even on failure before the form can be used again.
                const photoJobs = [
                    { photo: o.file, role: "child", operationId: a.id },
                    ...(l ? [{ photo: l.file, role: "secondary", operationId: a.id }] : []),
                    ...extraPeople.map((person, index) => ({ photo: person.file, role: "child", operationId: `${a.id}:child-${index + 2}` }))
                ];
                const photoResults = await Promise.allSettled(photoJobs.map(job => Promise.resolve().then(() => window.PrintFlowPrivatePhotos.upload({
                    ...job, cartToken: a.cartToken, productId: h.productId, variantId: a.variantId
                }))));
                const photoFailure = photoResults.find(result => result.status === "rejected");
                if (photoFailure) throw photoFailure.reason;
                const photoReferences = photoResults.map(result => result.value);
                a.media = { child: photoReferences[0] }, n("_printflow_child_media", a.media.child);
                if (o.eyeValue)
                    n("_printflow_child_eye_color", o.eyeValue);
                if (l?.eyeValue)
                    n("_printflow_secondary_eye_color", l.eyeValue);
                l && (n("_printflow_secondary_address_term", l.name.value.trim()), a.media.secondary = photoReferences[1], n("_printflow_secondary_media", a.media.secondary));
                if (siblingsEnabled && i.people.length > 2) {
                    n("_printflow_siblings_contract", "2026-10-27.siblings.v1");
                    n("Number of children", String(i.people.length - 1));
                    n("Child 1", o.name.value.trim());
                    n(m.roles[1].label, l.name.value.trim());
                    a.siblings = [];
                    for (const [index, person] of extraPeople.entries()) {
                        const prefix = `_printflow_child_${index + 2}`;
                        const media = photoReferences[(l ? 2 : 1) + index];
                        n(`Child ${index + 2}`, person.name.value.trim());
                        n(prefix + "_name", person.name.value.trim());
                        n(prefix + "_media", media);
                        for (const key of ["age_value", "age_unit", "gender", "eye_color"]) {
                            const value = person.card.querySelector(`[data-lbo-detail="${key}"]`)?.value || (key === "eye_color" ? person.eyeValue : "");
                            if (value)
                                n(prefix + "_" + key, value);
                        }
                        a.siblings.push({ name: person.name.value.trim(), media });
                    }
                }
                const f = i.people[0].eyeValue ? pe(i.people[0].eyeValue) : "", g = k("appearance")?.value.trim() || "", x = [f ? (E === "fr" ? "Yeux : " : "Eye color: ") + f : "", g].filter(Boolean).join("; "), y = k("dedication").value.trim();
                x && n("_printflow_appearance", x), y && n("_printflow_dedication", y), mt(a), i.request = a, t = true;
                const b = await ye(h.cartAddUrl + ".js", { method: "POST", body: r });
                if (!b.ok) {
                    if ([400, 401, 403, 404, 405, 413, 422].includes(b.status)) {
                        He(), i.request = null, p(c.addRejected, true);
                        return;
                    }
                    throw new Error("CART_UNKNOWN");
                }
                const _ = await b.json();
                if (!$e(_, a) || !await ae(a))
                    throw new Error("CART_UNKNOWN");
                _e(a);
            }
            catch {
                if (t && a) {
                    i.uncertain = a;
                    try {
                        if (await ae(a)) {
                            _e(i.uncertain || a);
                            return;
                        }
                    }
                    catch {
                    }
                    p(c.uncertain, true), V.hidden = false;
                }
                else
                    p(c.loadFailed, true);
            }
            finally {
                i.preparing = false, M(false);
            }
        }
        async function we(e) {
            if (i.returnFocus = e, p("", true), ue.hidden = true, u.open || (u.showModal(), document.documentElement.classList.add("lbo-is-open"), k("title").focus({ preventScroll: true })), B(), be(), i.uncertain) {
                p(c.uncertain, true), V.hidden = false, I();
                return;
            }
            i.loading = true, p(c.loading), I();
            try {
                await De(), p("");
            }
            catch {
                i.ready = false, p(c.loadFailed, true), ue.hidden = false;
            }
            finally {
                i.loading = false, I();
            }
        }
        const P = u.querySelector(".lbo__body"), N = d("span", "lbo__scroll-cue"), ke = d("i");
        N.setAttribute("aria-hidden", "true"), N.append(ke), u.querySelector(".lbo__shell").append(N);
        let xe = 0;
        function B() {
            xe || (xe = requestAnimationFrame(() => {
                xe = 0;
                const e = P.scrollHeight - P.clientHeight;
                N.hidden = !u.open || e < 2, N.style.top = P.offsetTop + 8 + "px", N.style.height = Math.max(0, P.clientHeight - 16) + "px";
                const t = Math.max(0, P.clientHeight - 16), a = Math.max(24, t * P.clientHeight / P.scrollHeight);
                ke.style.height = Math.min(t, a) + "px", ke.style.transform = `translateY(${e > 0 ? (t - a) * P.scrollTop / e : 0}px)`;
            }));
        }
        if (P.addEventListener("scroll", B, { passive: true }), typeof ResizeObserver == "function") {
            const e = new ResizeObserver(B);
            e.observe(P), e.observe(G);
        }
        else
            window.addEventListener("resize", B);
        G.addEventListener("submit", gt), k("close").addEventListener("click", () => u.close()), u.addEventListener("close", () => {
            document.documentElement.classList.remove("lbo-is-open"), B(), W(), i.returnFocus?.focus({ preventScroll: true });
        }), u.addEventListener("cancel", (e) => {
            i.busy && (e.preventDefault(), p(c.adding));
        }), u.addEventListener("click", (e) => {
            if (e.target === u && !i.busy) {
                const t = u.getBoundingClientRect();
                (e.clientX < t.left || e.clientX > t.right || e.clientY < t.top || e.clientY > t.bottom) && u.close();
            }
        }), ue.addEventListener("click", () => we(i.returnFocus));
        for (const e of J)
            e.addEventListener("click", (t) => {
                t.preventDefault(), t.stopImmediatePropagation(), he && we(e);
            });
        if (V.href = h.cartUrl, V.textContent = c.cartLink, !he) {
            for (const e of J)
                e.disabled = true, e.setAttribute("aria-disabled", "true");
            p(c.unavailable, true);
            return;
        }
        i.variants = Se(h.variants);
        const bt = new URL(window.location.href).searchParams.get("variant");
        i.selected = (i.variants.find((e) => e.id === bt) || i.variants.find((e) => e.available && m.variantFormats[e.id] === "hardcover_8x8") || i.variants.find((e) => e.available) || i.variants[0])?.id || null, i.ready = i.variants.length > 0, ht(), Ue();
        try {
            const e = JSON.parse(sessionStorage.getItem(fe) || "null");
            e && /^[a-f0-9-]{32,36}$/i.test(e.id) && Ce(e.variantId) && (i.uncertain = { ...e, destination: ["shopping", "checkout"].includes(e.destination) ? e.destination : Re ? "shopping" : "checkout" }, i.selected = e.variantId, M(false));
        }
        catch {
        }
        I(), Re && we(J[0] || null), window.addEventListener("pagehide", (e) => {
            for (const t of i.people)
                q(t);
            if (!e.persisted) {
                X();
                for (const t of i.people)
                    t.url && URL.revokeObjectURL(t.url), t.originalUrl && URL.revokeObjectURL(t.originalUrl), t.displayUrl && URL.revokeObjectURL(t.displayUrl), clearTimeout(t.checkTimer), t.paintId && cancelAnimationFrame(t.paintId);
            }
        });
    }
    function le() {
        document.querySelectorAll("[data-local-book-order]").forEach(it);
    }
    document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", le) : le(), document.addEventListener("shopify:section:load", le);
})();
(() => {
    "use strict";
    const mobile = window.matchMedia("(max-width: 760px)");
    const viewport = window.visualViewport;
    const fieldSelector = "input.lbo__input, textarea.lbo__textarea";
    function mount(dialog) {
        if (dialog.dataset.lboKeyboardMounted)
            return;
        dialog.dataset.lboKeyboardMounted = "true";
        const body = dialog.querySelector(".lbo__body");
        const footer = dialog.querySelector(".lbo__footer");
        if (!body || !footer)
            return;
        const bar = document.createElement("div");
        bar.className = "lbo__keyboard-bar";
        bar.hidden = true;
        const done = document.createElement("button");
        done.type = "button";
        done.className = "lbo__keyboard-done";
        done.textContent = "Done";
        done.setAttribute("aria-label", "Done typing");
        bar.append(done);
        footer.before(bar);
        let baseline = 0;
        let frame = 0;
        let revealFrame = 0;
        let timers = [];
        let editing = null;
        const height = () => viewport?.height || window.innerHeight;
        const focusedField = () => {
            const target = document.activeElement;
            return target instanceof HTMLElement && dialog.contains(target) && target.matches(fieldSelector) ? target : null;
        };
        function reset() {
            delete dialog.dataset.lboKeyboard;
            dialog.style.removeProperty("--lbo-visible-top");
            dialog.style.removeProperty("--lbo-visible-height");
            bar.hidden = true;
        }
        function reveal(target) {
            if (!target || target !== focusedField() || !dialog.open)
                return;
            const area = body.getBoundingClientRect();
            const field = target.getBoundingClientRect();
            const label = target.labels?.[0]?.getBoundingClientRect();
            const top = area.top + 10;
            const bottom = area.bottom - 10;
            const fieldTop = label && field.bottom - label.top < bottom - top ? label.top : field.top;
            if (field.bottom > bottom)
                body.scrollTop += field.bottom - bottom;
            else if (fieldTop < top)
                body.scrollTop -= top - fieldTop;
        }
        function update() {
            frame = 0;
            const target = focusedField();
            if (!dialog.open || !mobile.matches || viewport && Math.abs(viewport.scale - 1) > 0.05) {
                reset();
                return;
            }
            const current = height();
            if (!baseline)
                baseline = current;
            baseline = Math.max(baseline, current);
            const contracted = baseline - current > Math.max(120, baseline * 0.18);
            const keyboard = contracted && !!(target || editing);
            if (keyboard) {
                const top = Math.max(0, viewport?.offsetTop || 0);
                dialog.style.setProperty("--lbo-visible-top", `${Math.round(top + 8)}px`);
                dialog.style.setProperty("--lbo-visible-height", `${Math.max(100, Math.floor(current - 16))}px`);
                dialog.dataset.lboKeyboard = "true";
                bar.hidden = false;
            }
            else {
                reset();
                if (!target) {
                    baseline = current;
                    editing = null;
                }
            }
            cancelAnimationFrame(revealFrame);
            revealFrame = requestAnimationFrame(() => {
                if (target)
                    reveal(target);
            });
        }
        function schedule() {
            if (!frame)
                frame = requestAnimationFrame(update);
        }
        function settle() {
            timers.forEach(clearTimeout);
            timers = [100, 300, 600].map((delay) => setTimeout(schedule, delay));
            schedule();
        }
        dialog.addEventListener("focusin", (event) => {
            if (event.target.matches?.(fieldSelector)) {
                if (!editing)
                    baseline = Math.max(baseline, height());
                editing = event.target;
                settle();
            }
        });
        dialog.addEventListener("focusout", settle);
        done.addEventListener("click", () => {
            editing?.blur();
            done.focus({ preventScroll: true });
            settle();
        });
        dialog.addEventListener("close", () => {
            timers.forEach(clearTimeout);
            cancelAnimationFrame(frame);
            cancelAnimationFrame(revealFrame);
            frame = revealFrame = 0;
            editing = null;
            baseline = 0;
            reset();
        });
        new MutationObserver(() => {
            if (dialog.open) {
                baseline = height();
                editing = focusedField();
                schedule();
            }
        }).observe(dialog, { attributes: true, attributeFilter: ["open"] });
        viewport?.addEventListener("resize", schedule, { passive: true });
        viewport?.addEventListener("scroll", schedule, { passive: true });
        window.addEventListener("resize", schedule, { passive: true });
        window.addEventListener("pageshow", schedule);
        mobile.addEventListener?.("change", schedule);
        if (dialog.open) {
            baseline = height();
            schedule();
        }
    }
    const start = () => document.querySelectorAll('dialog.local-book-order[data-market="en"]').forEach(mount);
    if (document.readyState === "loading")
        document.addEventListener("DOMContentLoaded", start, { once: true });
    else
        start();
})();
